import { Button } from "@/components/ui/button";
import type { BillingIdentity } from "@/components/settings/BillingIdentityModal";
import { billingIdentityLabel } from "@/lib/billing-identity";

export function BillingIdentityLine({
  identity,
  onChange,
  disabled = false,
}: {
  identity: BillingIdentity | null;
  onChange: () => void;
  disabled?: boolean;
}) {
  if (!identity?.billing_id_number) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground" data-testid="billing-identity-line">
      <span>
        Se facturará a: <span className="font-medium text-foreground">{billingIdentityLabel(identity)}</span>
      </span>
      <Button
        type="button"
        variant="link"
        size="sm"
        className="h-auto p-0 text-xs"
        onClick={onChange}
        disabled={disabled}
        aria-label="Cambiar datos de facturación"
      >
        Cambiar
      </Button>
    </div>
  );
}
